
import styled from 'styled-components';
import { HeadlineStackWrapper, HeadlineWrapper, HeadlineItemWrapper } from '@mlb/react-patterns/v4/components/HeadlineStack/headlineStack.style';
import { GDBREAKPOINTS_FINAL } from '../themes/breakpoints';
export const TitleWrapper = styled.div`
    font-size: 24px;
    font-weight: bold;
    font-family: var(--gameday-primary-font);
    margin-bottom: 20px;
    @media(max-width: ${GDBREAKPOINTS_FINAL.SM_MAX}){
        margin-bottom: 16px;
    }
`;

export const MoreCoverageWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    font-weight: bold;
    width: 100%;

    ${HeadlineStackWrapper} {
        font-size: 18px;
        display: grid;
        grid-gap: 16px;
        grid-template-columns: repeat(auto-fill, minmax(325px, 1fr));
        ${HeadlineWrapper} {
            color: var(--gameday-primary-font-color);
            max-width: 285px;
            height: auto;
        }
        ${HeadlineItemWrapper} {
            padding: 0px;
            align-items: center;
        }
    }
    
`;
